var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 128,
    viewBox: "0 0 113 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 97,
    height: 122,
    rx: 12,
    fill: "#B4B4B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 94,
    height: 122,
    rx: 12,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 86,
    height: 43,
    rx: 12,
    fill: "#00A54F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.61 99L16.08 91.95L11.97 99H7.23L13.83 88.44L7.14 78.06H11.97L16.5 85.08L20.58 78.06H25.32L18.75 88.59L25.44 99H20.61ZM32.8364 95.67H39.7364V99H28.6364V78.06H32.8364V95.67ZM49.6359 99.21C48.1759 99.21 46.8559 98.96 45.6759 98.46C44.5159 97.96 43.5959 97.24 42.9159 96.3C42.2359 95.36 41.8859 94.25 41.8659 92.97H46.3659C46.4259 93.83 46.7259 94.51 47.2659 95.01C47.8259 95.51 48.5859 95.76 49.5459 95.76C50.5259 95.76 51.2959 95.53 51.8559 95.07C52.4159 94.59 52.6959 93.97 52.6959 93.21C52.6959 92.59 52.5059 92.08 52.1259 91.68C51.7459 91.28 51.2659 90.97 50.6859 90.75C50.1259 90.51 49.3459 90.25 48.3459 89.97C46.9859 89.57 45.8759 89.18 45.0159 88.8C44.1759 88.4 43.4459 87.81 42.8259 87.03C42.2259 86.23 41.9259 85.17 41.9259 83.85C41.9259 82.61 42.2359 81.53 42.8559 80.61C43.4759 79.69 44.3459 78.99 45.4659 78.51C46.5859 78.01 47.8659 77.76 49.3059 77.76C51.4659 77.76 53.2159 78.29 54.5559 79.35C55.9159 80.39 56.6659 81.85 56.8059 83.73H52.1859C52.1459 83.01 51.8359 82.42 51.2559 81.96C50.6959 81.48 49.9459 81.24 49.0059 81.24C48.1859 81.24 47.5259 81.45 47.0259 81.87C46.5459 82.29 46.3059 82.9 46.3059 83.7C46.3059 84.26 46.4859 84.73 46.8459 85.11C47.2259 85.47 47.6859 85.77 48.2259 86.01C48.7859 86.23 49.5659 86.49 50.5659 86.79C51.9259 87.19 53.0359 87.59 53.8959 87.99C54.7559 88.39 55.4959 88.99 56.1159 89.79C56.7359 90.59 57.0459 91.64 57.0459 92.94C57.0459 94.06 56.7559 95.1 56.1759 96.06C55.5959 97.02 54.7459 97.79 53.6259 98.37C52.5059 98.93 51.1759 99.21 49.6359 99.21ZM73.2272 99L68.6972 91.95L64.5872 99H59.8472L66.4472 88.44L59.7572 78.06H64.5872L69.1172 85.08L73.1972 78.06H77.9372L71.3672 88.59L78.0572 99H73.2272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.5b15916bd1701a8b89c29cf9ca3f48b3.svg";
export { ForwardRef as ReactComponent };